if (!customElements.get('countdown-timer')) {
  class Countdown extends HTMLElement {

    constructor() {
      super();
      this._initCountdown();
    }

    _initCountdown() {
      var container = this;
      var id = container.id;
      var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;
      var x = setInterval(function () {
        var now = new Date().getTime(),
        countDown = new Date().setHours(24, 0, 0, 0), // countDown = new Date().setHours(new Date().getHours() + 1, 0, 0, 0),
          distance = countDown - now;
  
        container.querySelector(`#${id} > .js-timer-days`).innerText = Math.floor(distance / (day)),
        container.querySelector(`#${id} > .js-timer-hours`).innerText = String(Math.floor((distance % (day)) / (hour))).padStart(2,"0"),
        container.querySelector(`#${id} >  .js-timer-minutes`).innerText = String(Math.floor((distance % (hour)) / (minute))).padStart(2,"0"),
        container.querySelector(`#${id} >  .js-timer-seconds`).innerText = String(Math.floor((distance % (minute)) / second)).padStart(2,"0");
      }, second)
    }
  }
  customElements.define('countdown-timer', Countdown);
}